import React from 'react'
import Image from 'next/image'

import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import FeaturesFooter from '@/components/sections/FeaturesFooter'
import OurValues from '@/components/sections/OurValues'
import Employee from '@/components/blocks/Employee.js'
import History from '@/components/blocks/History.js'
import mountainsImg from '@/assets/our-history/mountains.png'
import wifiPrinterImg from '@/assets/our-history/history-icons/wifi-printer.png'
import uploadImg from '@/assets/our-history/history-icons/upload.png'
import printerImg from '@/assets/our-history/history-icons/printer.png'
import rocketImg from '@/assets/our-history/history-icons/rocket.png'

const employeeList = [
  {
    name: 'Andrew Schaps',
    title: 'Chief Technology Officer',
    imgSrc: '/our-history/employees/andy-s.jpeg',
  },
  {
    name: 'Christopher Laverty',
    title: 'Engineer III',
    imgSrc: '/our-history/employees/chris-l.jpeg',
  },
  {
    name: 'Dan Kelly',
    title: 'Front-End Technical Lead',
    imgSrc: '/our-history/employees/dan-k.png',
  },
  {
    name: 'Glenn Rigby',
    title: 'MIS Functional Specialist',
    imgSrc: '/our-history/employees/glenn-r.jpeg',
  },
  {
    name: 'James Conroy',
    title: 'CEO',
    imgSrc: '/our-history/employees/jim-c.jpeg',
  },
  {
    name: 'Jorge Ortiz',
    title: 'Customer Success Lead',
    imgSrc: '/our-history/employees/jorge-o.jpeg',
  },
  {
    name: 'Joshua Keppen-Melendez',
    title: 'Senior Financial Analyst',
    imgSrc: '/our-history/employees/joshua-k.jpeg',
  },
  {
    name: 'Matthew Galloway',
    title: 'Corporate Controller',
    imgSrc: '/our-history/employees/matt-g.jpeg',
  },
  {
    name: 'Melissa Zufelt',
    title: 'Customer Success Lead',
    imgSrc: '/our-history/employees/melissa-z.jpeg',
  },
  {
    name: 'Nicole Potalivo',
    title: 'Director of Customer Success',
    imgSrc: '/our-history/employees/nicole-p.jpeg',
  },
  {
    name: 'Tia Aiken',
    title: 'Customer Success Specialist',
    imgSrc: '/our-history/employees/tia-a.png',
  },
]

const historyList = [
  {
    year: '2021',
    title: 'Neat Launches New Products',
    description: 'Neat becomes a full-service bookkeeping tool by launching NeatBooks® and NeatInvoices™. Now you can also access bookkeeping, invoicing, and file management while on-the go.',
  },
  {
    year: '2019',
    title: 'Neat Enables Automatic Syncing',
    description: 'Neat enables the ability to automatically sync your bank accounts and credit card transactions into the Neat desktop application.',
  },
  {
    year: '2017',
    title: 'Neat Focuses On Automated Bookkeeping',
    description: 'With an exit from hardware and desktop complete, Neat now focuses exclusively on developing automated bookkeeping solutions in a SaaS and Mobile framework.',
  },
  {
    year: '2016',
    title: 'Neat Leaves Scanner Market',
    description: 'Neat de-couples its software from hardware and officially ceases manufacture and sales of new scanners. Company focus is solely on Cloud and Mobile Apps.',
  },
  {
    year: '2015',
    title: 'Neat Sunsets Desktop Software',
    description: 'Neat sunsets its traditional desktop software app to focus future development efforts on cloud/SaaS application.',
  },
  {
    year: '2014',
    title: 'Neat Launches WiFi Scanner',
    description: 'Neat adds to its growing portfolio by releasing its first WiFi-enabled scanner.',
    icon: wifiPrinterImg,
  },
  {
    year: '2012',
    title: 'Neat Launches NeatCloud',
    description: 'Neat releases the first version of its cloud-based SaaS application, NeatCloud for storing and organizing digitized documents.',
    icon: uploadImg,
  },
  {
    year: '2007',
    title: 'Neat Launches First Desktop Scanner',
    description: 'Neat launches NeatDesk, its first Automatic Document Feeder (ADF) desktop scanner with bundled desktop software.',
    icon: printerImg,
  },
  {
    year: '2004',
    title: 'Neat Launches Its First Product',
    description: 'Neat launches NeatReceipts, a sheet-fed scanner with bundled desktop software for managing and organizing scanned documents.',
    icon: rocketImg,
  },
  {
    year: '2002',
    title: 'Neat Is Founded',
    description: 'The Neat Company is founded in Philadelphia as a desktop software application designed to manage expenses and documents.',
  },
]
const pageId = 'ourHistory'

export default function OurHistory() {
  return (
    <Layout.Content>
      <Section bgBlob>
        <Row center textCenter>
          <h1 style={{ fontSize: '40px' }}>About The Neat Company</h1>
        </Row>
        <Row>
          <Column center size={66}>
            <Rows gap={8}>
              <h2>Our Vision</h2>
              <p>Neat envisions a world where small business owners maximize growth of their business, where software transforms traditional accounting to both assess the past AND accelerate the future.</p>
            </Rows>
          </Column>
          <Column alignCenter fill={false} shrink size={33}>
            <Image
              alt="mountains"
              className="max-w-300"
              src={mountainsImg}
              style={{ height: 'auto' }}
            />
          </Column>
        </Row>
      </Section>

      <OurValues />

      <Section>
        <Row>
          <Column center textCenter>
            <h2>Our Team</h2>
          </Column>
        </Row>

        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}>
          {employeeList.map((employee) => (
            <Employee
              key={employee.name}
              imgSrc={employee.imgSrc}
              name={employee.name}
              title={employee.title}
            />
          ))}
        </div>
      </Section>

      <Section bgSecondary>
        <Column>
          <Row center>
            <h1>Our History</h1>
          </Row>
          <Row>
            <p><strong>Neat has an incredibly unique story in the tech space.</strong> We began offering a desktop expense tool and became the first vendor to develop a fully integrated software/hardware bundle. Neat software, coupled with the family of Neat Scanners was a first in the industry. Neat grew to support nearly two million consumers and businesses by helping homeowners with organization needs, and small business with expense and document management.</p>
          </Row>

          {historyList.map((history) => (
            <History
              key={history.year}
              description={history.description}
              icon={history.icon}
              title={history.title}
              year={history.year}
            />
          ))}

        </Column>
      </Section>

      <FeaturesFooter />

    </Layout.Content>
  )
}

OurHistory.layoutProps = {
  pageId,
}
